function firstText(...values) {
  for (const value of values) {
    const text = String(value || "").trim();
    if (text) return text;
  }
  return "";
}

function stripDoctorPrefix(value = "") {
  return String(value || "")
    .replace(/^\s*(dr|doctor)\.?\s+/i, "")
    .trim();
}

function selectDoctorLastName(...sources) {
  for (const source of sources) {
    if (!source) continue;

    const explicitLast = firstText(
      source?.doctorLastName,
      source?.last_name,
      source?.lastName,
      source?.surname,
      source?.family_name,
      source?.familyName,
    );
    if (explicitLast) return stripDoctorPrefix(explicitLast);

    const composite = firstText(
      source?.doctorPrescriptionName,
      source?.doctorName,
      source?.doctorFullName,
      source?.full_name,
      source?.display_name,
      source?.name,
      formatDoctorFullName(source),
    );

    const parts = stripDoctorPrefix(composite).split(/\s+/).filter(Boolean);
    if (parts.length) return parts[parts.length - 1];
  }

  return "";
}

export function formatDoctorFullName(source = {}) {
  const first = String(source?.first_name || source?.firstName || "").trim();
  const last = String(source?.last_name || source?.lastName || "").trim();
  return [first, last].filter(Boolean).join(" ").trim();
}

export function selectDoctorDisplayName(...sources) {
  for (const source of sources) {
    if (!source) continue;
    const next = firstText(
      source?.doctorName,
      source?.doctorFullName,
      source?.full_name,
      source?.display_name,
      source?.name,
      formatDoctorFullName(source),
    );
    if (next) return next;
  }
  return "";
}

export function selectDoctorPrescriptionName(...sources) {
  for (const source of sources) {
    if (!source) continue;

    const explicit = firstText(source?.doctorPrescriptionName, source?.prescriptionDoctorName);
    if (explicit) return explicit;
  }

  const lastName = selectDoctorLastName(...sources);
  return lastName ? `Dr ${lastName}` : "";
}

export function selectDoctorLicenseNumber(...sources) {
  for (const source of sources) {
    if (!source) continue;
    const next = firstText(
      source?.doctorLicenseNumber,
      source?.licenseNumber,
      source?.regNo,
      source?.registerNumber,
      source?.register_number,
      source?.medical_license_number,
      source?.license,
    );
    if (next) return next;
  }
  return "";
}
